import moment from "moment";
import { NUMERIC_DATA_TYPES, DATETIME_FORMATTER, DATE_FORMATTER, DATEONLY_FORMATTER } from "../../assets/extra/commonConstants";


export const hasAccess = (rights, code, adminType) => {
    if (adminType === 1 || adminType === 2) { return true }
    if (typeof code === 'string') {
        code = parseInt(code);
    }
    return rights.findIndex((rc) => code === rc) >= 0 ? true : false;
}

export const percenage = (num, total) => {
    if (!total || !num) return 0
    return (num / total) * 100
}
export const NumberFormatter = (value, decimal) => {
    if (Number.isInteger(value)) {
        return parseFloat(parseFloat(value).toFixed(0)).toLocaleString(
            "en-IN",
            {
                useGrouping: true,
                minimumFractionDigits: 0
            }
        );
    }
    else {
        return parseFloat(parseFloat(value).toFixed(decimal || 2)).toLocaleString(
            "en-IN",
            {
                useGrouping: true,
                minimumFractionDigits: decimal || 2
            }
        );
    }
};


export const jsPdfHeaderFooter = (data, reportTitle, userData, totalPagesExp) => {
    const doc = data.doc;
    doc.setTextColor(40);
    doc.addImage('/images/logo-66.png', 'JPEG', data.settings.margin.left, 5, 10, 10)
    doc.setFontSize(12);
    doc.setTextColor(16, 79, 162);
    doc.text(reportTitle, data.settings.margin.left + 12, 12);
    doc.setFontSize(10).setFont(undefined, 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Company Name : ', data.settings.margin.left + 85, 12);


    doc.setFontSize(9).setFont(undefined, 'normal');
    doc.text(userData.CompanyName, data.settings.margin.left + 115, 12);


    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7);
    var str = 'Page : ' + doc.internal.getNumberOfPages()
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(2);
    doc.text(str, data.settings.margin.left + 260, pageHeight - 2);
    doc.setFont('Roboto', 'normal');
    doc.text(`Report By : ${userData.UserName} [ ${userData.BranchName} ]`, data.settings.margin.left, pageHeight - 2);
    doc.text(`Report Time : ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")}`, data.settings.margin.left + 150, pageHeight - 2);
}


export const jsPdfHeaderFooterPortrait = (data, reportTitle, userData, totalPagesExp) => {
    const doc = data.doc;
    doc.setTextColor(40);
    doc.addImage('/images/logo-66.png', 'JPEG', data.settings.margin.left, 5, 14, 14)
    doc.setFontSize(12);
    doc.setTextColor(16, 79, 162);
    doc.text(reportTitle, data.settings.margin.left + 16, 12);
    doc.setFontSize(10).setFont(undefined, 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Company Name : ', data.settings.margin.left + 16, 18);


    doc.setFontSize(9).setFont(undefined, 'normal');
    doc.text(userData.CompanyName, data.settings.margin.left + 46, 18);


    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7);
    var str = 'Page : ' + doc.internal.getNumberOfPages()
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(10);
    doc.text(str, data.settings.margin.left + 97, pageHeight - 9);
    doc.setFont('Roboto', 'normal');
    doc.text(`Report By : ${userData.UserName} [ ${userData.BranchName} ]`, data.settings.margin.left, pageHeight - 2);
    doc.text(`Date : ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")}`, data.settings.margin.left + 153, pageHeight - 2);
}




export const jsPdfWillDrawCellCallback = (data, isBackWhite = false, companyID = '', fontSIZE) => {
    const pdoc = data.doc;
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        pdoc.setFont('Roboto', 'bold');
        pdoc.setFontSize(fontSIZE !== undefined ? fontSIZE : "8");


        if (data.row.raw.isSubHeadingRow)
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(23, 23, 23);
            } else {
                pdoc.setFillColor(245, 250, 254);
            }
        else if (data.row.raw.isTotalRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
            } else {
                pdoc.setFillColor(228, 235, 245);
            }
        }
        else if (data.row.raw.isHeaderRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(0, 0, 0);
            } else {
                pdoc.setFillColor(30, 89, 167);
                pdoc.setTextColor(255, 255, 255);
            }


        }


        if (data.row.raw.isHeaderRow) {
            data.cell.text[0] = data.cell.text[0];
        }
        else if (!data.row.raw.isSubHeadingRow && !data.row.raw.isChildRow) {
            if (data.column.raw.xlCol.dataType === 'quantity') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
            } else if (data.column.raw.xlCol.dataType === 'currency') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
            } else if (data.column.raw.xlCol.dataType === 'dateTime') {
                data.cell.text[0] = DateTimeFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'date') {
                data.cell.text[0] = DateFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'dateOnly') {
                data.cell.text[0] = DateOnlyFormatter(data.cell.text[0]);
            }
        } else if (data.row.raw.isChildRow) {
            pdoc.setFont('Roboto', 'normal');
        }
    } else if (data.row.raw.isDataRow) {
        if (data.column.raw.xlCol.dataType === 'quantity') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
        } else if (data.column.raw.xlCol.dataType === 'currency') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
        } else if (data.column.raw.xlCol.dataType === 'string') {
            if (data.cell.text.length > 2) {
                data.cell.text = data.cell.text;
            }
            else if (data.cell.text.length > 1 && data.cell.text.length < 2) {
                data.cell.text[0] = data.cell.text[0];
            } else {

                data.cell.text = data.cell.text;
            }
        }
    }
}

export const jsPdfWillDrawCellCallbackV2 = (data, isBackWhite = false, companyID = '', fontSIZE) => {
    const pdoc = data.doc;
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        pdoc.setFont('Roboto', 'bold');
        pdoc.setFontSize(fontSIZE !== undefined ? fontSIZE : "8");


        if (data.row.raw.isSubHeadingRow)
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(23, 23, 23);
            } else {
                pdoc.setFillColor(245, 250, 254);
            }
        else if (data.row.raw.isTotalRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
            } else {
                pdoc.setFillColor(228, 235, 245);
            }
        }
        else if (data.row.raw.isHeaderRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(0, 0, 0);
            } else {
                pdoc.setFillColor(30, 89, 167);
                pdoc.setTextColor(255, 255, 255);
            }


        }


        if (data.row.raw.isHeaderRow) {
            data.cell.text[0] = data.cell.text[0];
        }
        else if (!data.row.raw.isSubHeadingRow && !data.row.raw.isChildRow) {
            if (data.column.raw.xlCol.dataType === 'quantity') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
            } else if (data.column.raw.xlCol.dataType === 'currency') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
            } else if (data.column.raw.xlCol.dataType === 'dateTime') {
                data.cell.text[0] = DateTimeFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'date') {
                data.cell.text[0] = DateFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'dateOnly') {
                data.cell.text[0] = DateOnlyFormatter(data.cell.text[0]);
            }
        } else if (data.row.raw.isChildRow) {
            pdoc.setFont('Roboto', 'normal');
        }
    } else if (data.row.raw.isDataRow) {
        if (data.column.raw.xlCol.dataType === 'quantity') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
        } else if (data.column.raw.xlCol.dataType === 'currency') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
        } else if (data.column.raw.xlCol.dataType === 'string') {
            // if (data.cell.text.length > 2) {
            //     const cellData = data.cell.text.slice(0, 2);
            //     cellData[1] = cellData[1].length > 8 ? `${cellData[1].slice(0, 5)}...` : `${cellData[1]}...`
            //     data.cell.text = cellData;
            // }
            // else if (data.cell.text.length > 1 && data.cell.text.length < 2) {
            //     data.cell.text[0] = data.cell.text[0];
            // } else {

            data.cell.text = data.cell.text;
            // }
        }
    }
}

export const jsPdfDidParseCellCallback = (data, pdfColumns, itemValueColumns) => {
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        if (data.row.raw.isSubHeadingRow) {
            if (Array.isArray(data?.row?.raw?.subHeadingData)) {
                let prevColSpan = 0;
                data.row.raw.subHeadingData.forEach((subHeadingObj, index) => {
                    let cellValue = '';
                    if (subHeadingObj.hasOwnProperty('caption'))
                        cellValue += subHeadingObj.caption;
                    if (subHeadingObj.hasOwnProperty('value'))
                        cellValue += ' ' + subHeadingObj.value;
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = subHeadingObj.colSpan;
                    if (subHeadingObj.hasOwnProperty('rowSpan')) {
                        data.row.cells[startColSpanIndex].rowSpan = subHeadingObj.rowSpan;
                    }
                    data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align !== undefined ? subHeadingObj.align : "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    if (subHeadingObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align;
                    }
                    prevColSpan = startColSpanIndex + subHeadingObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isFooterRow) {
            if (Array.isArray(data?.row?.raw?.footerData)) {
                let prevColSpan = 0;
                data.row.raw.footerData.forEach((footerObj, index) => {
                    let cellValue = '';
                    const startColSpanIndex = prevColSpan;
                    if (footerObj.hasOwnProperty('caption'))
                        cellValue += footerObj.caption;
                    if (footerObj.hasOwnProperty('value'))
                        cellValue += ' ' + footerObj.value;


                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = 18;
                    data.row.cells[startColSpanIndex].styles.halign = "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    if (footerObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = footerObj.align;
                    }
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isSubFooterRow) {
            if (Array.isArray(data?.row?.raw?.subFooterData)) {
                let prevColSpan = 0;
                data.row.raw.subFooterData.forEach((footerObj, index) => {
                    data.row.cells[0].text = footerObj.value;
                    data.row.cells[0].colSpan = 13;
                    data.row.cells[0].styles.halign = "left";
                    data.row.cells[0].styles.font = "Roboto";
                    data.row.cells[0].styles.fontSize = "9";
                });
            }
        }
        else if (data.row.raw.isSignatureRow) {
            if (Array.isArray(data?.row?.raw?.subSignatureData)) {
                let prevColSpan = 0;
                data.row.raw.subSignatureData.forEach((footerObj, index) => {
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = footerObj.value;
                    data.row.cells[startColSpanIndex].colSpan = footerObj.colSpan;
                    data.row.cells[startColSpanIndex].styles.halign = footerObj.halign;
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isTotalRow) {
            let prevColSpan = 0;
            if (data.row.raw?.hasOwnProperty('collectionBy')) {
                data.row.cells[prevColSpan].colSpan = data.row.raw?.collectionColSpan;
                data.row.cells[prevColSpan].text = [data.row.raw?.collectionCaption + ' ' + data.row.raw?.collectionBy];
                prevColSpan += data.row.raw?.collectionColSpan;
            }
            data.row.cells[prevColSpan].colSpan = data.row.raw?.colSpan;
            data.row.cells[prevColSpan].text = [data.row.raw?.totalCaption || 'Total'];
            data.row.cells[prevColSpan].styles.halign = data.row.raw?.totalCaptionAllignment !== undefined ? data.row.raw?.totalCaptionAllignment : 'right';
        } else if (data.row.raw.isNoDataRow) {
            data.row.cells[0].colSpan = pdfColumns.length;
            data.row.cells[0].text = [data.row.raw?.rowCaption || ''];
            data.row.cells[0].styles.textColor = [255, 0, 0];
            data.row.cells[0].styles.halign = 'center';
        } else if (data.row.raw.isChildRow) {
            data.row.cells[1].colSpan = data.row.raw.colSpan;
            data.row.cells[1].text = [data.row.raw?.text || ''];
            data.row.cells[1].styles.halign = 'left';
        }
        else if (data.row.raw.isHeaderRow) {
            if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right";
            } else {
                data.cell.styles.halign = "left";
            }
        }
    } else if (data.row.section === 'head') {
        if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
        } else {
            data.cell.styles.halign = "left";
        }
    } else if (data.row.raw.isDataRow && data.row.raw.rowSpan && data.row.raw.rowSpan > 1) {
        data.row.cells[0].rowSpan = data.row.raw.rowSpan;
        data.row.cells[1].styles.valign = 'middle';
    }
}
export const jsPdfDidParseCellCallbackGST = (data, pdfColumns, itemValueColumns) => {
    if (!data.row.raw.isDataRow && data.row.section !== 'head') {
        if (data.row.raw.isSubHeadingRow) {
            if (Array.isArray(data?.row?.raw?.subHeadingData)) {
                let prevColSpan = 0;
                data.row.raw.subHeadingData.forEach((subHeadingObj, index) => {
                    let cellValue = '';
                    if (subHeadingObj.hasOwnProperty('caption'))
                        cellValue += subHeadingObj.caption;
                    if (subHeadingObj.hasOwnProperty('value'))
                        cellValue += ' ' + subHeadingObj.value;
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = subHeadingObj.colSpan;
                    if (subHeadingObj.hasOwnProperty('rowSpan')) {
                        data.row.cells[startColSpanIndex].rowSpan = subHeadingObj.rowSpan;
                    }
                    data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align !== undefined ? subHeadingObj.align : "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    if (subHeadingObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align;
                    }
                    prevColSpan = startColSpanIndex + subHeadingObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isSubTotalRow) {
            if (data.row.raw.hasOwnProperty('subTotalData')) {
                const subTotalData = data.row.raw.subTotalData;
                // const cellValue = `Subtotal: Total Collected ${(subTotalData.totalCollected).toFixed(2)}, Total Refund Amount ${(subTotalData.totalRefundAmount).toFixed(2)}, Net Collected ${(subTotalData.netCollected).toFixed(2)}`;
                data.row.cells[0].text = 'Subtotal';
                data.row.cells[0].colSpan = 2;
                data.row.cells[0].styles.halign = "left";
                data.row.cells[0].styles.font = "Roboto";
                data.row.cells[0].styles.fontSize = "9";
                data.row.cells[2].text = (subTotalData.totalCollected).toFixed(2);
                data.row.cells[2].colSpan = 1;
                data.row.cells[2].styles.halign = "right";
                data.row.cells[2].styles.font = "Roboto";
                data.row.cells[2].styles.fontSize = "9";
                data.row.cells[3].text = (subTotalData.totalRefundAmount).toFixed(2);
                data.row.cells[3].colSpan = 1;
                data.row.cells[3].styles.halign = "right";
                data.row.cells[3].styles.font = "Roboto";
                data.row.cells[3].styles.fontSize = "9";
                data.row.cells[4].text = (subTotalData.netCollected).toFixed(2);
                data.row.cells[4].colSpan = 1;
                data.row.cells[4].styles.halign = "right";
                data.row.cells[4].styles.font = "Roboto";
                data.row.cells[4].styles.fontSize = "9";
            }
        }
        else if (data.row.raw.isTotalOfAllDivisions) {
            if (data.row.raw.hasOwnProperty('totalData')) {
                const totalData = data.row.raw.totalData;
                // const cellValue = `Subtotal: Total Collected ${(totalData.totalCollected).toFixed(2)}, Total Refund Amount ${(totalData.totalRefundAmount).toFixed(2)}, Net Collected ${(totalData.netCollected).toFixed(2)}`;
                data.row.cells[0].text = 'Total Amount';
                data.row.cells[0].colSpan = 2;
                data.row.cells[0].styles.halign = "left";
                data.row.cells[0].styles.font = "Roboto";
                data.row.cells[0].styles.fontSize = "9";
                data.row.cells[2].text = (totalData.totalCollected).toFixed(2);
                data.row.cells[2].colSpan = 1;
                data.row.cells[2].styles.halign = "right";
                data.row.cells[2].styles.font = "Roboto";
                data.row.cells[2].styles.fontSize = "9";
                data.row.cells[3].text = (totalData.totalRefundAmount).toFixed(2);
                data.row.cells[3].colSpan = 1;
                data.row.cells[3].styles.halign = "right";
                data.row.cells[3].styles.font = "Roboto";
                data.row.cells[3].styles.fontSize = "9";
                data.row.cells[4].text = (totalData.netCollected).toFixed(2);
                data.row.cells[4].colSpan = 1;
                data.row.cells[4].styles.halign = "right";
                data.row.cells[4].styles.font = "Roboto";
                data.row.cells[4].styles.fontSize = "9";

            }
        }
        else if (data.row.raw.isFooterRow) {
            if (Array.isArray(data?.row?.raw?.footerData)) {
                let prevColSpan = 0;
                data.row.raw.footerData.forEach((footerObj, index) => {
                    let cellValue = '';
                    const startColSpanIndex = prevColSpan;
                    if (footerObj.hasOwnProperty('caption'))
                        cellValue += footerObj.caption;
                    if (footerObj.hasOwnProperty('value'))
                        cellValue += ' ' + footerObj.value;


                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = 18;
                    data.row.cells[startColSpanIndex].styles.halign = "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    if (footerObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = footerObj.align;
                    }
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isSubFooterRow) {
            if (Array.isArray(data?.row?.raw?.subFooterData)) {
                let prevColSpan = 0;
                data.row.raw.subFooterData.forEach((footerObj, index) => {
                    data.row.cells[0].text = footerObj.value;
                    data.row.cells[0].colSpan = 13;
                    data.row.cells[0].styles.halign = "left";
                    data.row.cells[0].styles.font = "Roboto";
                    data.row.cells[0].styles.fontSize = "9";
                });
            }
        }
        else if (data.row.raw.isSignatureRow) {
            if (Array.isArray(data?.row?.raw?.subSignatureData)) {
                let prevColSpan = 0;
                data.row.raw.subSignatureData.forEach((footerObj, index) => {
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = footerObj.value;
                    data.row.cells[startColSpanIndex].colSpan = footerObj.colSpan;
                    data.row.cells[startColSpanIndex].styles.halign = footerObj.halign;
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = "9";
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isTotalRow) {
            let prevColSpan = 0;
            if (data.row.raw?.hasOwnProperty('collectionBy')) {
                data.row.cells[prevColSpan].colSpan = data.row.raw?.collectionColSpan;
                data.row.cells[prevColSpan].text = [data.row.raw?.collectionCaption + ' ' + data.row.raw?.collectionBy];
                prevColSpan += data.row.raw?.collectionColSpan;
            }
            data.row.cells[prevColSpan].colSpan = data.row.raw?.colSpan;
            data.row.cells[prevColSpan].text = [data.row.raw?.totalCaption || 'Total'];
            data.row.cells[prevColSpan].styles.halign = data.row.raw?.totalCaptionAllignment !== undefined ? data.row.raw?.totalCaptionAllignment : 'right';
        } else if (data.row.raw.isNoDataRow) {
            data.row.cells[0].colSpan = pdfColumns.length;
            data.row.cells[0].text = [data.row.raw?.rowCaption || ''];
            data.row.cells[0].styles.textColor = [255, 0, 0];
            data.row.cells[0].styles.halign = 'center';
        } else if (data.row.raw.isChildRow) {
            data.row.cells[1].colSpan = data.row.raw.colSpan;
            data.row.cells[1].text = [data.row.raw?.text || ''];
            data.row.cells[1].styles.halign = 'left';
        }
        else if (data.row.raw.isHeaderRow) {
            if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right";
            } else {
                data.cell.styles.halign = "left";
            }
        }
    } else if (data.row.section === 'head') {
        if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
        } else {
            data.cell.styles.halign = "left";
        }
    } else if (data.row.raw.isDataRow && data.row.raw.rowSpan && data.row.raw.rowSpan > 1) {
        data.row.cells[0].rowSpan = data.row.raw.rowSpan;
        data.row.cells[1].styles.valign = 'middle';
    }
}
export const DateTimeFormatter = (date) => {
    return moment(date).format(DATETIME_FORMATTER);
}




export const DateFormatter = (date) => {
    return moment(date).format(DATE_FORMATTER);
}
export const DateOnlyFormatter = (date) => {
    return moment(date).format(DATEONLY_FORMATTER);
}

export const removeDuplicatesFromArray = (array, property) => {
    const uniqueValues = new Set() // Set to store unique property values
    const uniqueArray = [] // Array to store unique objects

    array.forEach((obj) => {
        const propertyValue = obj[property] // Get the property value of the current object

        if (!uniqueValues.has(propertyValue)) {
            // If property value is not already in the set
            uniqueValues.add(propertyValue) // Add it to the set
            uniqueArray.push(obj) // Add the object to the unique array
        }
    })

    return uniqueArray
}

export function getTotalByKey(arr, keys) {
    let totals = {};

    keys.forEach(key => {
        totals[key] = 0;
    });

    arr.forEach(obj => {
        keys.forEach(key => {
            totals[key] += Number(obj[key]) || 0;
        });
    });
    // Fix to 2 decimals
    keys.forEach(key => {
        totals[key] = Number(totals[key].toFixed(2));
    });
    return totals;
}
export function getTotalByKey1(arr, keys) {
    let totals = {};

    keys.forEach(key => {
        totals[key] = 0;
    });
    arr.forEach(obj => {
        keys.forEach(key => {
            totals[key] += parseFloat(obj[key]) || 0;
        });
    });
    // Round totals to two decimal places
    for (let key in totals) {
        totals[key] = parseFloat(totals[key].toFixed(2));
    }

    return totals;
}
